module.exports = __webpack_public_path__ + "img/x-mark.d4252e73.svg";